// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Kn_j","title":"InfoRow_title__J0jk2"};